import { render } from "./AssoComponent.vue?vue&type=template&id=664de487&scoped=true"
import script from "./AssoComponent.vue?vue&type=script&lang=js"
export * from "./AssoComponent.vue?vue&type=script&lang=js"

import "./AssoComponent.vue?vue&type=style&index=0&id=664de487&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664de487"]])

export default __exports__